import SmsPreview from './SmsPreview';

export default SmsPreview;
